import React from 'react';

import classes from './FormLoader.module.css';

const formLoader = () => {
    return (
        <div className={classes.FormLoader}>
            <div className={[classes.bar, classes.bar2].join(' ')}></div>
        </div>

    )
}

export default formLoader;